import http from '@/utils/request';
import { API_BASE } from '@/config/index';

// 图片、文件上传 API 路径
export const UPLOAD_FILE_API = `${API_BASE.open}/api/file/upload`;

/**
 * 图片、文件上传
 *
 * @param {*} data
 * @returns
 */
export const uploadFile = (data) => {
  return http.post({
    url: UPLOAD_FILE_API,
    data,
    loading: true,
  });
};

// 微信H5授权
export function getSignature(params) {
  const url = `${API_BASE.base}/tradingServer/open/getSignature`;
  return http.get({
    url,
    params,
    cache: true,
    loading: true,
  });
}

/**
 * 权限
 */
// export function getAuthority(params) {
//   return http.get({
//     url: `${API_BASE.base}/authManage/authority/resource`,
//     params: {
//       systemType: 'BB_CRM_APP',
//       ...params,
//       // systemType: 'BB_CRM_APP',
//     },
//     loading: false,
//   });
// }

/**
 * 埋点上报
 *
 */
export function sendBehaviorReport(data) {
  const url = `${API_BASE.apm}/behavior/report`;
  return http.post({
    server: 'apm',
    loading: false,
    url,
    data,
  });
}
